/**
 * Demo Mode Utilities
 *
 * Helpers for managing demo mode behavior
 */

import { message } from 'antd';

export const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true';

/**
 * Wrap mutation functions to show demo message instead of executing
 */
export function withDemoProtection(fn, actionName = 'action') {
  if (!isDemoMode) {
    return fn;
  }

  return (...args) => {
    message.info({
      content: `Demo Mode: ${actionName} is disabled in demo mode`,
      duration: 3,
    });
    console.log(`[DEMO MODE] Blocked ${actionName}:`, args);
    return Promise.resolve({ blocked: true });
  };
}

/**
 * Check if we're in demo mode and show warning
 */
export function checkDemoMode(actionName) {
  if (isDemoMode) {
    message.warning({
      content: `This is a read-only demo. ${actionName} is not available.`,
      duration: 4,
    });
    return true;
  }
  return false;
}

/**
 * Props helper to disable buttons/actions in demo mode
 */
export function getDemoModeProps(originalProps = {}) {
  if (!isDemoMode) {
    return originalProps;
  }

  return {
    ...originalProps,
    disabled: true,
    title: 'Disabled in demo mode',
  };
}

/**
 * Get demo mode banner config
 */
export function getDemoBannerConfig() {
  if (!isDemoMode) {
    return null;
  }

  return {
    message: '🎬 Demo Mode - This is a read-only demonstration with sample data from Geneva, Switzerland',
    type: 'info',
    closable: false,
    showIcon: true,
  };
}
